import { render, staticRenderFns } from "./outboundDialog.vue?vue&type=template&id=220fb348&scoped=true"
import script from "./outboundDialog.vue?vue&type=script&lang=js"
export * from "./outboundDialog.vue?vue&type=script&lang=js"
import style0 from "./outboundDialog.vue?vue&type=style&index=0&id=220fb348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220fb348",
  null
  
)

export default component.exports